export default "__VITE_ASSET__dcd0a6ba__"